import React from "react";
import { ArrowRight, Check, Sparkles, Crown, Rocket } from "lucide-react";

const plans = [
  {
    name: "BKS Starter",
    tag: "Get Off The Ground",
    icon: Rocket,
    description: "The perfect entry point to start closing wholesale deals fast.",
    features: [
      "Core wholesaling training modules",
      "Step-by-step deal walkthroughs",
      "Community access",
    ],
    cta: "Start With Starter",
    url: "https://whop.com/checkout/plan_uh0nLHinFm6So",
    popular: false,
  },
  {
    name: "BKS Foundation",
    tag: "Most Popular",
    icon: Sparkles,
    description: "Everything you need to build a real $10K+/mo wholesaling business.",
    features: [
      "Everything in Starter",
      "Advanced deal-finding systems",
      "Cash buyers network access",
      "Live group coaching calls",
    ],
    cta: "Get Foundation",
    url: "https://whop.com/checkout/plan_OiYqYspCM2UXz",
    popular: true,
  },
  {
    name: "BKS Elite",
    tag: "Highest Level Access",
    icon: Crown,
    description: "For serious closers who want direct mentorship and priority support.",
    features: [
      "Everything in Foundation",
      "1:1 mentorship with BKS",
      "Priority support & deal review",
      "Elite mastermind access",
    ],
    cta: "Go Elite",
    url: "https://whop.com/checkout/plan_DrDhTx2HW6nw6",
    popular: false,
  },
];

export default function Plans() {
  return (
    <section id="plans" className="relative py-20 md:py-28 border-t border-white/5 overflow-hidden">
      <div className="glow-orb" style={{ width: 460, height: 460, background: "#2fe1c8", top: -100, left: "40%", opacity: 0.12 }} />

      <div className="relative z-10 max-w-6xl mx-auto px-6">
        <div className="text-center">
          <div className="label-eyebrow">Choose Your Path</div>
          <h2 className="mt-3 text-white text-4xl md:text-5xl font-bold tracking-tight">
            Pick The Plan <span className="title-gradient">That Fits You.</span>
          </h2>
          <p className="mt-4 text-white/60 max-w-2xl mx-auto">
            Skip the call and get instant access. Choose the mentorship level that matches your goals
            and you&apos;re in.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {plans.map((p) => {
            const Icon = p.icon;
            return (
              <div
                key={p.name}
                className={`relative card-dark p-7 flex flex-col transition-all duration-300 hover:-translate-y-1 ${
                  p.popular ? "plan-popular" : ""
                }`}
              >
                {p.popular && (
                  <div className="absolute -top-3 left-1/2 -translate-x-1/2">
                    <span className="inline-flex items-center gap-1.5 text-[10px] tracking-[0.18em] uppercase font-bold text-black bg-[#3df3c2] px-3 py-1 rounded-full shadow-lg shadow-[#3df3c2]/30">
                      <Sparkles className="w-3 h-3" /> {p.tag}
                    </span>
                  </div>
                )}

                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-[#3df3c2]/10 border border-[#3df3c2]/25 flex items-center justify-center">
                    <Icon className="w-5 h-5 text-[#3df3c2]" />
                  </div>
                  {!p.popular && (
                    <span className="text-[10px] tracking-[0.18em] uppercase text-white/45 font-semibold">
                      {p.tag}
                    </span>
                  )}
                </div>

                <h3 className="mt-5 text-white text-2xl font-bold">{p.name}</h3>
                <p className="mt-2 text-white/60 text-sm leading-relaxed">{p.description}</p>

                <ul className="mt-6 space-y-3 flex-1">
                  {p.features.map((f) => (
                    <li key={f} className="flex items-start gap-2.5 text-sm text-white/80">
                      <Check className="w-4 h-4 text-[#3df3c2] mt-0.5 flex-shrink-0" />
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>

                <a
                  href={p.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`mt-8 w-full py-3.5 rounded-xl text-sm font-semibold flex items-center justify-center gap-2 transition-all ${
                    p.popular ? "btn-cta" : "btn-mint"
                  }`}
                >
                  {p.cta}
                  <ArrowRight className="w-4 h-4" />
                </a>
              </div>
            );
          })}
        </div>

        <p className="text-center text-white/50 text-sm mt-10">
          Still have questions? Reach out to us for a 1:1 call before you decide.
        </p>
      </div>
    </section>
  );
}
